import { render, staticRenderFns } from "./all-score-staff.vue?vue&type=template&id=0137814c&"
import script from "./all-score-staff.vue?vue&type=script&lang=js&"
export * from "./all-score-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports